export enum CalibrationStatusEnum {
  "Aberto" = 1,
  "Calibrado" = 2,
  "Não Calibrado" = 3,
}
